/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'signup': {
    width: 27,
    height: 26,
    viewBox: '0 0 27 26',
    data: '<path pid="0" _fill="#d90e15" d="M23.942 6.888l-.924.924-4.103-4.103.924-.924c.85-.85 2.23-.85 3.08 0l1.023 1.022c.85.852.85 2.23 0 3.081zm-19.8 12.42l3.277 3.279-4.534 1.256zm.819-1.644L17.683 4.94l4.103 4.103L9.063 21.767zM24.152 1.553a3.92 3.92 0 0 0-5.545 0L3.062 17.097a.871.871 0 0 0-.223.384L.795 24.86a.871.871 0 0 0 1.072 1.072l7.38-2.044a.871.871 0 0 0 .383-.224L25.174 8.12a3.925 3.925 0 0 0 0-5.545z"/>'
  }
})
